import React, { Component,Fragment } from 'react'
import Cards from './Cards';
import { Grid } from 'semantic-ui-react';
import { Typography } from '@material-ui/core';
import { firestore } from '../../Firebase/firebaseConfig';
import Explore from './Explore';



class Services extends Component {

  state = {
    all_services: [],
    service: "",
    viewExplore : false,
    exploreData : '',
    vendors : []
  }

  componentDidMount() {
    window.scrollTo(0,0)
    let newArr= []

    firestore.collection('Services').get().then(data=>{
    
      data.docs.map(d=> 
        firestore.collection("Services").doc(d.id).get().then(doc=>{
          const obj = { image : doc.data().image,sName : d.id,about : doc.data().about }
          this.setState(prevState=>({ ...prevState,service  : obj}))
          const copy = {...this.state.service}
          newArr.push(copy)
          this.setState({all_services : newArr})
          })   
        )            
        })
  }
  
  componentWillUnmount(){
    this.setState({
    all_services: [],
    service: "",
    viewExplore : false,
    exploreData : '',
    vendors : []
    })
  }

  viewExplorePage(index){
    this.setState({ viewExplore : true })
    const data=this.state.all_services.filter((s,i)=> i=== index  )
    this.setState({ exploreData : data[0] })
    if(data[0] === undefined) {  }
    else {
      firestore.collection("Services").doc(data[0].sName).get().then(doc=>{
        this.setState({ vendors : doc.data().data })
      })
    }
  }

  viewService=()=>{
    this.setState({ viewExplore : false, vendors : [] })
  }

  
  render() {
      if(this.state.exploreData=== undefined)  this.setState({ exploreData : { sName: '',about : '' } })
      else {
         var {sName,about} = this.state.exploreData
      }

      let colors=["red","orange","yellow","olive","green","teal","blue","violet","purple","pink"]
      let random=()=> Math.floor(Math.random()*10)

    return (
      <Fragment>
      {

        this.state.viewExplore ? 
        <Explore 
        sName={sName} 
        back={()=>this.viewService()} 
        about={about} 
        vendorLists={this.state.vendors}
        />
        : 
        (
          <div className="container mt-5 mb-5">
          <Typography variant="h2" align="center">
              Our Services
          </Typography>
            <hr />
            <Grid centered>
              {this.state.all_services.map((s,index)=> 
              <Cards color={colors[random()]}  key={index} src={s.image} view={()=>this.viewExplorePage(index)} serviceName={s.sName} about={s.about} />
            )}
            </Grid>
          </div>
        )
      }
      
      </Fragment>
    )
  }
}

export default Services




